import { render, staticRenderFns } from "./ReferredCompaniesCreate.vue?vue&type=template&id=23b1bc47"
import script from "./ReferredCompaniesCreate.vue?vue&type=script&lang=js"
export * from "./ReferredCompaniesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports